import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    add: translate({ id: 'global.add' }),
    vehicles: translate({ id: 'vehicles.form.list.yourVehicles' }),
  }))

  return api
}
